import { render, staticRenderFns } from "./agent_cancellation.vue?vue&type=template&id=86455a0a&scoped=true"
import script from "./agent_cancellation.vue?vue&type=script&lang=js"
export * from "./agent_cancellation.vue?vue&type=script&lang=js"
import style0 from "./agent_cancellation.vue?vue&type=style&index=0&id=86455a0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86455a0a",
  null
  
)

export default component.exports